import '@babel/polyfill';
import './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';

import 'velocity-animate';
import 'interactjs/dist/interact.min.js';
import './style/main.styl';

// attach custom api on fetch.
import './lib/custom-fetch';
import './lib/logger';

// register global mixin
import './mixin';
// register global directives
import './directives';
// register global components
import './components';
// register global event bus
import './event-bus';

import Vue from 'vue';
import App from './App.vue';

import {sync} from 'vuex-router-sync';
import router from './router/router';
import store from './store';

sync(store, router);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    // Prevent blank screen in Electron builds
    this.$router.push('/');
  }
}).$mount('#app');
